import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	dropzone: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	browse: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	browseAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	missingToken: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	dropzone: {
		id: 'issue-create-commons.attachments-field.dropzone',
		defaultMessage: 'Drop files to attach or',
		description: 'dropzone for drag and drop',
	},
	browse: {
		id: 'issue-create-commons.attachments-field.browse',
		defaultMessage: 'Browse',
		description: 'browse file explorer link',
	},
	browseAriaLabel: {
		id: 'issue-create-commons.attachments-field.browse-aria-label',
		defaultMessage: 'Browse attachment',
		description: 'Aria label for browse file explorer link Within the Create modal dialog',
	},
	missingToken: {
		id: 'issue-create-commons.attachments-field.missing-token',
		defaultMessage: 'Something went wrong',
		description: 'Error message when token is missing',
	},
});

export default messages;
